import React from "react";
import { formatCurrency } from "../../helpers/estimateTotals";

export function ReportSubtotalRow({ label, amount, variant = "print" }) {
  const rowClassName = variant === "print" ? "erp-subtotal-row" : "er-subtotal-row";

  return (
    <div className={rowClassName}>
      <span>{label}</span>
      <span>{formatCurrency(amount)}</span>
    </div>
  );
}
